/**
 * @param {Date} date
 */
export function toIsoDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function todayIso() {
  return toIsoDate(new Date())
}

/**
 * @param {string} isoDate
 * @param {number} offsetDays
 */
export function shiftIsoDate(isoDate, offsetDays) {
  const date = new Date(`${isoDate}T12:00:00`)
  date.setDate(date.getDate() + offsetDays)
  return toIsoDate(date)
}

/**
 * @param {string} isoDate
 */
export function nextIsoDate(isoDate) {
  return shiftIsoDate(isoDate, 1)
}

/**
 * @param {string} isoDate
 */
export function formatDayHeading(isoDate) {
  return new Date(`${isoDate}T12:00:00`).toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
}
